import nls from '../es/TimeoutDialog.js';
export default {
  ...nls,
};
